// Calculate payload size
function calculatePayloadSize(payload) {
    let payloadString = JSON.stringify(payload);
    return new TextEncoder().encode(payloadString).length;
}
// Normalize ecommerce payload: items always array, value always number
function normalizeEcommercePayload(payload) {
    const ecommerce = payload.ecommerce;
    if (!ecommerce) {
        return payload;
    }

    if (ecommerce.items !== undefined) {
        ecommerce.items = Array.isArray(ecommerce.items) ? ecommerce.items : [ecommerce.items];
    }

    if (ecommerce.value !== undefined) {
        const value = parseFloat(ecommerce.value);
        ecommerce.value = isNaN(value) ? 0 : value;
    }

    return payload;
}
// Push single event to dataLayer, clearing previous ecommerce object first
function pushEcommerce(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(normalizeEcommercePayload(payload));
}
// Send payload to dataLayer
function sendToDataLayer(payload) {
    normalizeEcommercePayload(payload);
    let items = payload.ecommerce.items || [];

    // Fresh copy for every chunk, so chunks don't share the same items array
    const createChunk = () => ({
        ...payload,
        ecommerce: {
            ...payload.ecommerce,
            items: [],
        },
    });
    let basePayloadSize = calculatePayloadSize(createChunk());

    let currentPayload = createChunk();
    let currentPayloadSize = basePayloadSize;

    for (let i = 0; i < items.length; i++) {
        let item = items[i];
        let itemSize = calculatePayloadSize(item);

        if (currentPayloadSize + itemSize < 8069 || currentPayload.ecommerce.items.length === 0) {
            currentPayload.ecommerce.items.push(item);
            currentPayloadSize += itemSize;
        } else {
            pushEcommerce(currentPayload);
            currentPayload = createChunk();
            currentPayload.ecommerce.items.push(item);
            currentPayloadSize = basePayloadSize + itemSize;
        }
    }

    if (currentPayload.ecommerce.items.length > 0 || items.length === 0) {
        pushEcommerce(currentPayload);
    }
}

// Helper to set json data in a local storage
function setStorageItem(key, value) {
    localStorage.setItem(`ecommerce_analytic.${key}`, JSON.stringify(value));
}
// Helper to fetch a parsed json data from a local storage
function getStorageItem(key) {
    const data = localStorage.getItem(`ecommerce_analytic.${key}`);

    if (!data) {
        return {};
    }

    return JSON.parse(data);
}
// Helper for removing data from a local storage
function removeStorageItem(key) {
    localStorage.removeItem(`ecommerce_analytic.${key}`);
}
// TO DO
function ViewItemList(items, list_id = 'сatalog-product', list_name = 'Каталог продуктов') {
    if (0 === Object.keys(items).length) {
        return;
    }

    // Remove added_at property
    for (const key in items) {
        delete items[key].added_at;
    }

    let payload = {
        event: 'view_item_list',
        ecommerce: {
            item_list_id: list_id,
            item_list_name: list_name,
            items: items
        },
    };

    return console.log(payload);
        // sendToDataLayer(payload);
}

function SelectItem(item) {
    const payloadItem = item['item_id'] ? item : datasetNormalizer(item);

    const payload = {
        event: 'select_item',
        ecommerce: {
            currency: 'MDL',
            value: payloadItem.price,
            items: payloadItem,
        },
    };
    // return console.log(payload);
    pushEcommerce(payload);
}

/**
 * Helper to grab dataset attributes and normalize its values.
 *
 * @param dataset
 * @returns {{item_name: *, item_id: *, item_category: *, item_brand: *, price: *, discount: *, item_list_id: *, item_list_name: *, index: *}}
 */
function datasetNormalizer(dataset) {
    // console.log('Helper datasetNormalizer() executed');
    // return console.table(data);
    return {
        'item_name': dataset.ecom_name, // Product title
        'item_id': dataset.ecom_id, // Unique product's id
        'item_category': dataset.ecom_category, // Category
        'item_brand': dataset.ecom_brand, // Brand
        'price': dataset.ecom_price, // Actual price
        'discount': dataset.ecom_discount, // Calculated discount if applicable
        'item_list_id': dataset.ecom_list_id, // Unique section id where a user is coming from
        'item_list_name': dataset.ecom_list_name, // List name in Russian language
        'index': dataset.ecom_index, // Item position in a slider, starts from 1, 2 and etc...
    };
}

// function ViewItem(item) {
    // const viewItem = getStorageItem('view_item');
    // if (1 === item['viewed_times']) {
    //     return console.log('Item has been already viewed');
    // }
    // Set viewed times
    // item['viewed_times'] = 1;
    // Save changes
    // setStorageItem('view_item', item);
    // Remove viewed times for data layer structure
    // delete item.viewed_times;
    // if (parseInt(item.item_id) === parseInt(viewItem.item_id)) {
    //     item['item_list_name'] = viewItem['item_list_name'];
    //     item['item_list_id'] = viewItem['item_list_id'];
    //     item['index'] = viewItem['index'];
    // }

    // const payload = {
    //     event: 'view_item',
    //     ecommerce: {
    //         'currency': 'MDL',
    //         'value': item.price,
    //         'items': item
    //     },
    // };
// return console.log(payload);
//     dataLayer.push(payload);
// }

function AddToCart(item) {
    item.quantity = 1;

    const payload = {
        event: 'add_to_cart',
        ecommerce: {
            currency: 'MDL',
            value: item.price,
            items: item,
        },
    };
    // return console.log(payload);
    pushEcommerce(payload);
}

function RemoveFromCart(item) {
    delete item.quantity;

    const payload = {
        event: 'remove_from_cart',
        ecommerce: {
            currency: 'MDL',
            value: item.price,
            items: item,
        },
    };
    // return console.log(payload);
    pushEcommerce(payload);
}

function ViewCart(ecomItems) {
    if (0 === Object.keys(ecomItems).length) {
        return;
    }

    const { totalPrice, payloadItems } = getTotalPriceAndPayloadItems(ecomItems);
    const payload = {
        event: 'view_cart',
        ecommerce: {
            currency: 'MDL',
            value: totalPrice,
            items: payloadItems,
        },
    };
    // return console.log(payload);
    sendToDataLayer(payload);
}

function BeginCheckout(ecomItems, orderType = 'standard') {
    let payload = {};
    const currency = 'MDL';

    switch (orderType) {
        case 'standard':
            const { totalPrice, payloadItems, totalDiscount } = getTotalPriceAndPayloadItems(ecomItems);

            payload = {
                event: 'begin_checkout',
                ecommerce: {
                    currency: currency,
                    value: totalPrice,
                    discount: totalDiscount,
                    items: payloadItems,
                },
            };
            break;

        // Quick and credit order types
        case 'quick':
        case 'credit':
            const item = ecomItems;
            const price = parseFloat(item.price);
            const discount = parseFloat(item.discount);

            payload = {
                event: 'begin_checkout',
                ecommerce: {
                    currency: currency,
                    value: price,
                    discount: discount,
                    items: [item],
                },
            };
            break
    }
    // return console.log(payload);
    sendToDataLayer(payload);
}

function AddShippingInfo(items, code, shipping) {
    const { totalPrice, payloadItems } = getTotalPriceAndPayloadItems(items);
    const payload = {
        event: 'add_shipping_info',
        ecommerce: {
            currency: 'MDL',
            value: totalPrice,
            shipping_tier: shipping,
            items: payloadItems,
        },
    };

    // return console.log(payload);
    sendToDataLayer(payload);
}
function AddPaymentInfo(typeId) {
    let paymentType;

    switch (typeId) {
        case '1':
            paymentType = 'CASH';
            break;
        case '3':
            paymentType = 'CARD';
            break;
        case '5':
            paymentType = 'IBAN';
            break;
        case '8':
            paymentType = 'CARD ON DELIVERY';
            break;
        default:
            paymentType = 'CARD';
    }

    fetch('/ajax/ecom_get_basket_items/')
        .then(response => response.json())
        .then(result => {
            const { totalPrice, payloadItems } = getTotalPriceAndPayloadItems(result.items);
            const payload = {
                event: 'add_payment_info',
                ecommerce: {
                    currency: 'MDL',
                    value: totalPrice,
                    payment_type: paymentType,
                    items: payloadItems,
                },
            };
            // return console.log(payload);
            sendToDataLayer(payload);
        })
    ;

}

function Purchase(items, code, shipping, transaction, user) {
    const { totalPrice, payloadItems } = getTotalPriceAndPayloadItems(items, {
        'affiliation': 'Cart'
    });
    const payload = {
        event: 'purchase',
        ecommerce: {
            transaction_id: transaction,
            currency: 'MDL',
            value: totalPrice,
            shipping: shipping,
            coupon: code,
            items: payloadItems,
            user_data: {
                user_id: btoa(user.phone),
                email: user.email,
                phone: user.phone,
            },
        },
    };

    // return console.log(payload);
    sendToDataLayer(payload);

}
function Credit(item, transaction, value, user_phone) {
    // Remove redundant currency
    delete item.currency;

    // Add affiliation
    item['affiliation'] = 'Credit';

    const payload = {
        event: 'purchase',
        ecommerce: {
            transaction_id: transaction,
            currency: 'MDL',
            value: value,
            items: [item],
            user_data: {
                user_id: btoa(user_phone),
                phone: user_phone,
            },
        },
    };
    // return console.log(payload);
    pushEcommerce(payload);
}

function Quick(item, transaction, value, user_phone) {
    delete item.currency;

    // Add an affiliation type
    item['affiliation'] = 'Quick';

    const payload = {
        event: 'purchase',
        ecommerce: {
            transaction_id: transaction,
            currency: 'MDL',
            value: value,
            items: [item],
            user_data: {
                user_id: btoa(user_phone),
                phone: user_phone,
            },
        },
    };
    // return console.log(payload);

    pushEcommerce(payload);
}

// Wishlist and Comparison
function AddToWishlist(dataset) {
    const payload = {
        event: 'add_to_wishlist',
        ecommerce: {
            currency: 'MDL',
            items: datasetNormalizer(dataset)
        },
    };
    // return console.log(payload);
    pushEcommerce(payload);
}

function AddToComparison(dataset) {
    // return console.table(dataset);
    const payload = {
        event: 'add_to_compare',
        ecommerce: {
            currency: 'MDL',
            items: datasetNormalizer(dataset)
        },
    };
    // return console.log(payload);
    pushEcommerce(payload);
}

//! Promotion
function ViewPromotion(id, name, creative_name, creative_slot, data) {
    let payload = {
        event: 'view_promotion',
        ecommerce: {
            promotions: [
                {
                    promotion_id: id,
                    promotion_name: name ?? creative_name,
                    creative_name: creative_name ?? name,
                    creative_slot: creative_slot ?? 'top__slider',
                },
            ],
        },
    };
    if (data) {
        data.items.forEach(item => {
            delete item.quantity;
            delete item.currency;
            item['item_list_id'] = id;
            item['item_list_name'] = name ?? creative_name;
        });
        payload.ecommerce.items = data.items;
        sendToDataLayer(payload);
    } else {
        pushEcommerce(payload);
    }
}

function SelectPromotion(id, name, creative_name, creative_slot) {
    console.log('Select promotion');
    pushEcommerce({
        event: 'select_promotion',
        ecommerce: {
            promotions: [
                {
                    promotion_id: id,
                    promotion_name: name ?? creative_name,
                    creative_name: creative_name ?? name,
                    creative_slot: creative_slot ?? 'top__slider',
                },
            ],
        },
    });
}

// Search
function SearchProductsQuery(query, data) {
    // console.log('Search products query');
    // dataLayer.push({ ecommerce: null });
    dataLayer.push({
        event: 'view_search_results',
        search_query: query,
    });

    ViewItemList(JSON.parse(data));
}

// Other
function AddBonusCode(data, code) {
    console.log('Add bonus code');
    let parsedData = JSON.parse(data);
    let list_data = JSON.parse(getCookie('product_list_data') || '[]');

    let currency = parsedData.items[0].currency;
    let totalPrice = 0;
    parsedData.items.forEach(item => {
        delete item.currency;
        item['item_list_id'] = parsedData.list_id;
        item['item_list_name'] = parsedData.list_name;

        let itemPrice = parseFloat(item.price);
        let itemQuantity = parseInt(item.quantity) || 1;
        totalPrice += itemPrice * itemQuantity;

        if (list_data.length > 0) {
            let product = list_data.find(
                list_item => parseInt(list_item.product_id) === parseInt(item.item_id)
            );
            if (product) {
                item['item_list_id'] = product.list_id;
                item['item_list_name'] = product.list_name;
            }
        }
    });

    let payload = {
        event: 'add_bonus_code',
        ecommerce: {
            currency: currency,
            value: totalPrice,
            uds_code: code,
            items: parsedData.items,
        },
    };

    sendToDataLayer(payload);
}
function FormSuccess(name) {
    console.log('Form success');
    // dataLayer.push({ ecommerce: null });
    dataLayer.push({
        event: 'form_success',
        form_name: name,
    });
}
function Navigation(nav) {
    console.log('Navigation');
    // dataLayer.push({ ecommerce: null });
    dataLayer.push({
        event: 'navigation',
        nav: JSON.parse(nav),
    });
}

// $(document).on(
//     'click',
//     '.list__data, .product__item, .slider__item',
//     function () {
//         let product_id = $(this).data('id');
//         let list_id = $(this).data('list_id');
//         let list_name = $(this).data('list_name');
//
//         let list_title = $(this)
//             .closest('.tovars')
//             .find('.product__title')
//             .text()
//             .trim();
//
//         if (list_title) {
//             list_id = list_title;
//             list_name = list_title;
//         }
//
//         let list_data = JSON.parse(getCookie('product_list_data') || '[]');
//         let found = false;
//         let updated = false;
//
//         for (let item of list_data) {
//             if (item.product_id === product_id) {
//                 found = true;
//                 if (item.list_id !== list_id || item.list_name !== list_name) {
//                     item.list_id = list_id;
//                     item.list_name = list_name;
//                     updated = true;
//                 }
//                 break;
//             }
//         }
//
//         if (!found) {
//             list_data.push({product_id, list_id, list_name});
//             updated = true;
//         }
//
//         if (updated) {
//             setCookie('product_list_data', JSON.stringify(list_data), 7);
//         }
//     }
// );

function updateCookieProductList(item) {
    console.log('updateCookieProductList');

    let product_id = item.data('id');
    let list_id = item.data('list_id');
    let list_name = item.data('list_name');
    let list_title = item
    .closest('.tovars')
    .find('.product__title')
    .text()
    .trim();

    if (list_title) {
        list_id = list_title;
        list_name = list_title;
    }

    let list_data = JSON.parse(getCookie('product_list_data') || '[]');
    let found = false;
    let updated = false;

    for (let item of list_data) {
        if (item.product_id === product_id) {
            found = true;
            if (item.list_id !== list_id || item.list_name !== list_name) {
                item.list_id = list_id;
                item.list_name = list_name;
                updated = true;
            }
            break;
        }
    }

    if (!found) {
        list_data.push({product_id, list_id, list_name});
        updated = true;
    }

    if (updated) {
        setCookie('product_list_data', JSON.stringify(list_data), 7);
    }
}

function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    document.cookie = name + '=' + value + ';' + expires + ';path=/';
}
function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
function eraseCookie(name) {
    document.cookie = name + '=; Max-Age=0; path=/;';
}


function AddContactInfo(data) {
    console.log('Add contact info');
    console.log(data);
    let parsedData = JSON.parse(data);

    console.log(parsedData)

    let contactInfo = {
        event: 'add_contact_info',
        ecommerce: {
            contact_details: {
                first_name: parsedData.name,
                last_name: parsedData.lastName,
                phone: parsedData.phone,
                address: {
                    street: parsedData.street,
                    home_number: parsedData.home_number,
                },
            },
        },
    };
    console.log(contactInfo)

    // Отправляем данные в dataLayer или другую систему
    sendToDataLayer(contactInfo);
}

/**
 *
 * @param items
 * @param attributes
 * @returns {{totalPrice: number, payloadItems: *[], totalDiscount: number}}
 */
function getTotalPriceAndPayloadItems(items, attributes = {}) {
    let
        totalPrice = 0,
        totalDiscount = 0,
        payloadItems = []
    ;

    for (const key in items) {
        const item = items[key];
        // Add attributes
        if (0 !== Object.keys(attributes).length) {
            for (const attributesKey in attributes) {
                item[attributesKey] = attributes[attributesKey];
            }
        }

        const qty = parseInt(item.quantity);
        const price = parseFloat(item.price);
        const discount = parseFloat(item.discount);

        totalDiscount += discount * qty;
        totalPrice += price * qty;
        payloadItems.push(item);
    }

    return { totalPrice, payloadItems, totalDiscount };
}